var moment = require('moment-timezone');
var DeliveryOptionsController = /** @class */ (function () {
    /*@ngInject*/
    function DeliveryOptionsController($scope, $rootScope, $filter, Util, CartService, warehouseService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.Util = Util;
        this.cartService = CartService;
        this.deliveryOptions = [];
        this.freeShipping = 250;
        this.timeZone;
        this.WarehouseService = warehouseService;
        this.dropshipFee = 0.00;
    }
    DeliveryOptionsController.prototype.showColdHoldMessage = function () {
        var eastToday = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
        var theDay = 0 + eastToday.getDay();
        var theHour = 0 + eastToday.getHours();
        var theMinute = 0 + eastToday.getMinutes();
        return (theDay == 4 && (theHour > 16 || theHour == 16 && theMinute >= 30))
            || (theDay == 5 && (theHour < 16 || theHour == 16 && theMinute <= 40));
    };
    DeliveryOptionsController.prototype.selectDeliveryOption = function (option) {
        this.selectedRow = option;
        if (this.isFreeShipping(option)) {
            option.cost = 0;
        }
        if (this.onShippingOptionSelect)
            this.onShippingOptionSelect({ option: option });
        this.$rootScope.$emit('update-delivery-date', option.latestDeliveryDate);
    };
    DeliveryOptionsController.prototype.isFreeShipping = function (deliveryOption) {
        return this.selectedAddress.countryCode == 'US' && deliveryOption.cost === 0 && this.cartService.cartSummaryData.discountedSubtotal >= this.freeShipping;
    };
    DeliveryOptionsController.prototype.displayDate = function (str) {
        return this.cartService.displayDate(str);
    };
    DeliveryOptionsController.prototype.getDeliveryOptions = function (address) {
        var _this = this;
        this.showDeliveryOptions = true;
        this.viewDeliveryOptionsStarted = false;
        this.deliveryOptionsError = false;
        this.viewDeliveryOptionsStarted = true;
        this.cartService.getShipingOptions().then(function (response) {
            _this.deliveryOptions = response.data.response;
            _this.dropshipFee = address.isDropShip ? _this.deliveryOptions[0].dropShipFee : 0;
            _this.getWarehouseTimeZone();
            _this.deliveryOptions.sort(function (method1, method2) {
                var date1 = Date.parse(method1.latestDeliveryDate);
                var date2 = Date.parse(method2.latestDeliveryDate);
                return date1 - date2;
            });
        }, function () {
            _this.deliveryOptionsError = true;
            _this.viewDeliveryOptionsStarted = false;
        });
    };
    DeliveryOptionsController.prototype.getWarehouseTimeZone = function () {
        var _this = this;
        this.timeZone = '';
        this.WarehouseService.getAllWarehouses().then(function (warehouses) {
            var warehouseTimezone = warehouses.find(function (warehouse) { return warehouse.id == _this.deliveryOptions[0].shipFromWarehouse; }).timezone;
            _this.timeZone = moment.tz(warehouseTimezone).zoneAbbr('z');
        });
    };
    DeliveryOptionsController.prototype.$onChanges = function (changes) {
        if (changes.selectedAddress) {
            this.getDeliveryOptions(this.selectedAddress);
        }
    };
    return DeliveryOptionsController;
}());
export default DeliveryOptionsController;
//# sourceMappingURL=delivery-options.controller.js.map